import React from 'react';

const ImgPlaceholderTransparentBackground = () => {
    return (
        <svg
            width='100'
            height='56'
            viewBox='0 0 100 56'
            xmlns='http://www.w3.org/2000/svg'
        >
            <defs>
                <pattern
                    id='checkerboard'
                    width='10'
                    height='10'
                    patternUnits='userSpaceOnUse'
                >
                    <rect width='10' height='10' fill='var(--background)' />
                    <rect
                        width='5'
                        height='5'
                        fill='var(--background-darker)'
                    />
                    <rect
                        x='5'
                        y='5'
                        width='5'
                        height='5'
                        fill='var(--background-darker)'
                    />
                </pattern>
            </defs>

            {/* fondo transparente simulado */}
            <rect
                width='100'
                height='56'
                fill='url(#checkerboard)'
                stroke='var(--border)'
                strokeWidth='0'
            />
            <svg
                width='350'
                height='315'
                viewBox='0 0 350 315'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
            ></svg>

            {/* icono de imagen centrado */}
            <g
                transform='translate(39, 17)'
                stroke='var(--grey-400)'
                strokeWidth='1.6'
                fill='none'
                strokeLinecap='round'
                strokeLinejoin='round'
            >
                <rect x='0' y='0' width='22' height='22' rx='3' />
                <circle cx='6.5' cy='6.5' r='2' />
                <path d='M0 15.5l6-6a2 2 0 0 1 2.8 0l7.7 7.7' />
                <path d='M12.5 18l3.5-3.5a2 2 0 0 1 2.8 0l3.2 3.2' />
            </g>
        </svg>
    );
};

export default ImgPlaceholderTransparentBackground;
